const StockSetting = {
  path: "",
  name: "",
  redirect: "stock/:id",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  meta: {
    requiresAuth: true,
    parent: "/branch-management",
    activeUrl: "/branch-management",
    isChildren: true,
    lv: 2,
  },
  children: [
    {
      path: "stock/:id",
      name: "Branch Stock",
      redirect: "stock/:id",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      meta: {
        requiresAuth: true,
        parent: "/branch-management",
        activeUrl: "/branch-management",
        isChildren: true,
        lv: 3,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/manageBranch/stock"),
          meta: {
            requiresAuth: true,
            activeUrl: "/branch-management",
            parent: "/branch-management",

            lv: 3,
          },
        },
        {
          path: "inventory/:stock_id",
          name: "Branch Stock Inventory",
          component: () => import("@/views/pages/manageBranch/stock/inventory"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/branch-management",
            parent: "/branch-management",

            lv: 3,
          },
        },
      ],
    },
  ],
};
const Branch = {
  path: "",
  name: "",
  redirect: "/branch-management",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/branch-management",
      redirect: "/branch-management",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Branch Management",
      meta: {
        requiresAuth: true,
        activeUrl: "/branch-management",
        parent: "branch",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/manageBranch"),
          meta: {
            requiresAuth: true,
            activeUrl: "/branch-management",
            parent: "branch",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Branch Management Detail",
          component: () => import("@/views/pages/manageBranch/Detail.vue"),
          meta: {
            requiresAuth: true,
            isChildren: true,

            activeUrl: "/branch-management",
            parent: "branch",
            lv: 3,
          },
        },
        {
          path: "inventory/:id",
          name: "Inventory Detail",
          component: () => import("@/views/pages/manageBranch/Inventory.vue"),
          meta: {
            requiresAuth: true,
            isChildren: true,

            activeUrl: "/branch-management",
            parent: "branch",
            lv: 3,
          },
        },
        {
          path: "inventory/log/:id",
          name: "Inventory Log",
          component: () => import("@/views/pages/manageBranch/log.vue"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/branch-management",
            parent: "branch",
            lv: 3,
          },
        },
        StockSetting,
      ],
    },
  ],
  meta: { requiresAuth: true },
};

export default Branch;
